import React from "react";

const PP = () => {
  return (
    <>
      <p>LAST UPDATED: January 2025</p>
      <p>PRIVACY NOTICE</p>
      <p>
        This Privacy Notice is meant to help you understand how StratCap, LLC,
        StratCap Investment Management, LLC, and StratCap Securities, LLC
        (collectively, “StratCap,” “we,” “us,” or “our”) collects, uses, and
        discloses your personal information (“Personal Information”) in
        connection with the services we provide. This Privacy Notice applies
        wherever this Privacy Notice is provided to you and also applies to
        those with whom we interact with in our business-to-business
        relationships.
      </p>
      <p>California Notice at Collection</p>
      <p>
        For our California residents, we collect personal information as
        described under the “Personal Information We Collect” section of this
        Privacy Notice below. We use the Personal Information collected for our
        business and commercial purposes as described under the “Use of Personal
        Information” section below. We do not sell or share your Personal
        Information. We retain your Personal Information as described under the
        “Retention of Personal Information” section below.
      </p>
      <p>Personal Information We Collect</p>
      <p>
        We collect the following categories of Personal Information about you:
      </p>
      <p>
        Identifiers, such as name, contact information and online identifiers;
      </p>
      <p>
        Personal information, as defined in the California customer records law,
        such as name, contact information and employment information;
      </p>
      <p>
        Characteristics of protected classifications under California or federal
        law, such as age and citizenship;
      </p>
      <p>
        Commercial information, such as transaction information and history;
      </p>
      <p>
        Internet or network activity information, such as browsing history,
        online behavior and interactions with our website;
      </p>
      <p>Geolocation data, such as device location and IP location;</p>
      <p>
        Audio, electronic, visual and similar information, such as call
        recordings created in connection with our business activities;
      </p>
      <p>
        Professional or employment-related information, such as employer or the
        entity with which you are affiliated;
      </p>
      <p>
        Inferences drawn from any of the Personal Information listed above to
        create a profile or summary about, for example, an individual’s
        preferences and characteristics; and
      </p>
      <p>
        Sensitive Personal Information, such as Social Security number, driver’s
        license number, passport number, and account log-in. Please note that we
        do not use your Sensitive Personal Information to infer characteristics
        about you.
      </p>
      <p>
        We collect this Personal Information directly from you, advertising
        networks, internet service providers, data analytics providers,
        government entities, operating systems and platforms, social networks,
        and data brokers.
      </p>
      <p>Use of Personal Information</p>
      <p>
        We may use your Personal Information for a variety of business and
        commercial purposes. These include:
      </p>
      <p>to provide our products and services;</p>
      <p>for our vendor management purposes;</p>
      <p>to accomplish our business purposes and objectives, including to:</p>
      <p>develop, improve, and maintain our products and services;</p>
      <p>personalize, advertise, and market our products and services;</p>
      <p>conduct research, analytics, and data analysis;</p>
      <p>maintain our facilities and infrastructure;</p>
      <p>undertake quality and safety assurance measures;</p>
      <p>conduct risk and security control and monitoring;</p>
      <p>detect and prevent fraud;</p>
      <p>perform identity verification;</p>
      <p>
        perform accounting, audit, and other internal functions, such as
        internal investigations; and
      </p>
      <p>
        comply with our legal and regulatory obligations, legal process, and
        internal policies; maintain records; and exercise and defend legal
        claims;
      </p>
      <p>with you consent; and</p>
      <p>for any other legitimate business purpose.</p>
      <p>
        To the extent that we retain any Personal Information in deidentified
        form, we publicly commit to maintaining and using the deidentified data
        without attempting to reidentify the deidentified data.
      </p>
      <p>Disclosures of Personal Information</p>
      <p>
        We may disclose any of the above categories of Personal Information to
        third parties (such as our advertising networks, affiliates, our service
        providers and our business partners) for our operational business
        purposes.
      </p>
      <p>
        We may disclose your Personal Information as part of a sale, transfer,
        or other business transaction, such as a corporate divestiture, merger,
        consolidation, acquisition, reorganization of sale or assets, or in the
        event of bankruptcy or dissolution.
      </p>
      <p>
        We may also disclose your Personal Information with your consent, or for
        any other legitimate business purposes.
      </p>
      <p>Retention of Personal Information</p>
      <p>
        We retain your Personal Information for the period necessary to fulfill
        the purposes outlined in this Privacy Notice unless a longer retention
        period is required or permitted by law. Please note that in many
        situations we must retain all, or a portion, of your Personal
        Information to comply with our legal obligations, resolve disputes,
        enforce our agreements, and to protect against fraudulent, deceptive, or
        illegal activity, or for another one of our business purposes.
      </p>
      <p>International Transfers of Personal Information</p>
      <p>
        All Personal Information processed by us may be transferred, processed,
        and stored anywhere in the world, including, but not limited to, the
        United States or other countries, which may have data protection laws
        that are different from the laws where you live. We endeavor to
        safeguard your Personal Information consistent with the requirements of
        applicable laws.
      </p>
      <p>Sale or Share of Personal Information</p>
      <p>
        We have not “sold” or “shared” Personal Information as such terms are
        defined in the California Consumer Privacy Act (“CCPA”). This includes
        the Personal Information of individuals under sixteen years of age.
      </p>
      <p>Privacy Rights</p>
      <p>
        Residents in certain states, including California, may have certain
        rights to their Personal Information. These include:
      </p>
      <p>
        (1) The right to access your Personal Information. You may request that
        we disclose to you the following information covering the 12 months
        preceding your request:
      </p>
      <p>
        The categories of Personal Information we collected about you and the
        categories of sources from which we collected such Personal Information;
      </p>
      <p>The specific pieces of Personal Information we collected about you;</p>
      <p>
        The business or commercial purpose for collecting Personal Information
        about you;
      </p>
      <p>
        The categories of Personal Information about you that we otherwise
        shared or disclosed, and the categories of third parties with whom we
        shared or to whom we disclosed such Personal Information (if
        applicable);
      </p>
      <p>
        The list of specific third parties to whom we have disclosed your
        Personal Information (if applicable).
      </p>
      <p>
        (2) The right to delete Personal Information we have collected about
        you.
      </p>
      <p>
        (3) The right to correct Personal Information we have collected about
        you.
      </p>
      <p>
        (4) The right to opt-out of any selling or sharing of your Personal
        Information.
      </p>
      <p>
        (5) The right to opt-out of our use of your Personal Information for
        targeted advertising.
      </p>
      <p>
        (6) The right to opt-out of our use of your Personal Information in
        connection with profiling in furtherance of decisions that produce legal
        or similarly significant effects (and in certain states, the right to
        question the reason that the profiling resulted in the decision, and if
        feasible, be informed of what actions might have been taken to secure a
        different decision).
      </p>
      <p>
        (7) The right to limit our use and disclosure of your Sensitive Personal
        Information.
      </p>
      <p>(8) The right to appeal our response to your request.</p>
      <p>
        In some instances, we may decline to honor your request where an
        exception applies. Nonetheless, you have the right to be free from
        unlawful discrimination or retaliation for exercising any of the above
        privacy rights.
      </p>
      <p>How to Make Requests</p>
      <p>
        You, or an agent that you authorize to make a request on your behalf may
        exercise your privacy rights by contacting us. You may make a request by
        contacting us at:
      </p>
      <p>(1) 949.681.9125</p>
      <p>or</p>
      <p>(2) Contacting us via one of the methods listed on our .</p>
      <p>
        We will verify your identity by asking you to provide us with your name,
        email address, and account number. To designate an individual to act on
        your behalf, please provide .
      </p>
      <p>
        We do not currently respond to do-not-track signals. We respond to other
        browser controls, such as the Global Privacy Control, in accordance with
        applicable law.
      </p>
      <p>Changes to this Privacy Notice</p>
      <p>
        We may change or update this Privacy Notice from time to time. When we
        do, we will post the revised Privacy Notice on this page with a new
        “Last Updated” date. By continuing to use our services after any changes
        to the Privacy Notice are posted, you acknowledge and accept those
        changes. We may provide you with a reasonable opportunity to withdraw
        consent to any further materially different collection, processing, or
        transfer of previously collected personal information under the changed
        Privacy Notice.
      </p>
      <p>Contact Us</p>
      <p>You may contact us by:</p>
      <p>(1) Calling us at 949.681.9125 or</p>
      <p>(2) Contacting us via one of the methods listed on our .</p>
    </>
  );
};

export default PP;
